module.exports = __webpack_public_path__ + "static/img/edwecate.com.0a9d379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/edwecate.com.jpg
// module id = 31
// module chunks = 1